import React, { Component } from 'react';
import ColButton from '../../../Elements/ColButton';
import PanelBorder from '../../../Elements/PanelBorder';
import InfoBox from '../../../Elements/InfoBox';
import InputWithClear from '../../../Elements/InputComponents/InputWithClear';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';

class PIAddNewFieldworkPeriods extends Component {
  static timespan = '';

  constructor(props) {
    super(props);

    const nopd =
      typeof props.numberOfPlanningDetails === 'undefined' || props.numberOfPlanningDetails < 1
        ? 1
        : props.numberOfPlanningDetails;
    this.state = {
      submitHandler: props.submitHandler,
      startDates: this.generateStartDates(nopd),
      endDates: this.generateEndDates(nopd),
      applyDateRow: this.generateApplyDateRowArray(nopd),
      numberOfNewFieldworkPeriods: 1,
    };
  }

  componentDidMount() {}

  generateApplyDateRowArray(numberOfPlanningDetails) {
    const arr = new Array(numberOfPlanningDetails);
    return arr.fill(true);
  }

  generateStartDates(numberOfPlanningDetails) {
    const tempStartDates = [];
    for (let i = 0; i < numberOfPlanningDetails; i++) {
      tempStartDates[i] = this.addDays(
        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 12, 0, 0),
        i
      );
    }
    return tempStartDates;
  }

  generateEndDates(numberOfPlanningDetails) {
    const tempEndDates = [];
    for (let i = 0; i < numberOfPlanningDetails; i++) {
      tempEndDates[i] = this.addDays(
        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 12, 0, 0),
        i
      );
    }
    return tempEndDates;
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  renderApplyCheckBox(indexOfRow) {
    return (
      <td
        className='border-0'
        key='applytr'
      >
        <input
          type='checkbox'
          checked={this.state.applyDateRow[indexOfRow]}
          onChange={(e) => {
            const tempArray = [...this.state.applyDateRow];
            tempArray[indexOfRow] = e.target.checked;
            this.setState({
              applyDateRow: tempArray,
            });
          }}
        />
      </td>
    );
  }

  renderDateRows() {
    const rows = [];

    for (let i = 0; i < this.state.numberOfPlanningDetails; i++) {
      rows.push(
        <tr
          className='border'
          key={`dateRowTr${i}`}
        >
          <td
            className='border-0'
            key='periodTr'
          >
            {`Period ${i + 1}`}
          </td>
          {this.renderApplyCheckBox(i)}
        </tr>
      );
    }

    return rows;
  }

  renderStatusSelect() {
    return (
      <tr className='border'>
        <td className='border-0'>
          <div className='hover rounded p-1 m-1'>
            <InputWithClear
              labelText='Number of New Fieldwork Periods'
              type={InputTypesEnum.Number}
              value={this.state.numberOfNewFieldworkPeriods}
              onChange={(fieldName, newValue) => {
                this.setState({
                  numberOfNewFieldworkPeriods: newValue,
                });
              }}
            />
          </div>
        </td>
      </tr>
    );
  }

  isAllApplyDateRowSelected() {
    for (let i = 0; i < this.state.applyDateRow.length; i++) {
      if (!this.state.applyDateRow[i]) {
        return false;
      }
    }
    return true;
  }

  SelectOrDeselectAllApplyDateRow() {
    const allSelected = this.isAllApplyDateRowSelected();
    const tempArray = [...this.state.applyDateRow];
    for (let i = 0; i < tempArray.length; i++) {
      tempArray[i] = !allSelected;
    }
    this.setState({ applyDateRow: tempArray });
  }

  renderTableHeadCell(text) {
    const allSelected = this.isAllApplyDateRowSelected();
    return (
      <th className='border-0'>
        {text === 'Apply' ? (
          <span
            className='pointer'
            onClick={() => this.SelectOrDeselectAllApplyDateRow()}
          >
            Apply ({allSelected ? 'Des' : 'S'}elect all)
          </span>
        ) : (
          text
        )}
      </th>
    );
  }

  renderTableHead() {
    return (
      <thead className='border-0'>
        <tr>
          {this.renderTableHeadCell('Fieldwork Period')}
          {this.renderTableHeadCell('Apply')}
        </tr>
      </thead>
    );
  }

  renderChangesWillBeAppliedInTheseCountries() {
    const countryList = this.props.countries.length > 0 ? this.props.countries.join(', ') : '';
    const infotext =
      this.props.countries.length > 0 ? (
        <>
          It will be applied on the following countr{this.props.countries.length > 1 ? 'ies' : 'y'}:
          <br />
          {this.props.countries.length > 0 ? countryList : 'None'}
        </>
      ) : (
        'There is no selected country.'
      );
    return (
      <InfoBox
        text={infotext}
        rotated='-'
      />
    );
  }

  render() {
    return (
      <PanelBorder
        headerText='Add New Fieldwork Periods'
        clickOnCancel={this.props.clickOnCancel}
        icon='fa-solid fa-plus-circle'
      >
        <div className='text-center'>
          <div className='d-flex justify-content-center m-1'>
            {this.renderChangesWillBeAppliedInTheseCountries()}
            <table className='border-0 w-75'>
              {/* {this.renderTableHead()} */}
              <tbody>
                {/* {this.renderDateRows()} */}
                {this.renderStatusSelect()}
              </tbody>
            </table>
          </div>

          <ButtonFooterContainer>
            <ColButton
              text='Cancel'
              onClick={this.props.clickOnCancel}
            />
            <ColButton
              text='Create New Periods'
              onClick={() => {
                this.props.submitHandler(this.state.numberOfNewFieldworkPeriods);
              }}
              icon='fa-solid fa-plus-circle'
            />
          </ButtonFooterContainer>
        </div>
      </PanelBorder>
    );
  }
}

export default PIAddNewFieldworkPeriods;
